import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../Layout"
import UnidadesForm from "../modais/UnidadesForm"
class UnidadesEditForm extends Component {
  constructor() {
    super()
    this.onSucess = this.onSucess.bind(this)
  }
  onSucess() {
    this.props.history.push("/unidades")
  }
  render() {
    return (
      <Layout tabActive="Unidades orçamentárias">
        <UnidadesForm isEditing={true} callBackUnidades={this.onSucess} />
      </Layout>
    )
  }
}
export default withRouter(UnidadesEditForm)



// WEBPACK FOOTER //
// ./src/views/unidades-orcamentarias/UnidadesEditForm.js